let cachedVersion = null;

export const getAppVersion = () => {
  if (cachedVersion) {
    return Promise.resolve(cachedVersion);
  }

  if (typeof window !== 'undefined' && 'fetch' in window) {
    return getVersionFromSW();
  }
  
  return Promise.resolve(null);
};

const getVersionFromSW = async () => {
  try {
    const response = await fetch('/sw.js');
    const text = await response.text();
    
    const versionRegex = /\/\/ version:\s*(\d+)\.(\d+)\.(\d+)/;
    const match = text.match(versionRegex);
    
    if (match) {
      cachedVersion = `${match[1]}.${match[2]}.${match[3]}`;
      return cachedVersion;
    }
  } catch (error) {
    console.warn('Error fetching sw.js:', error);
  }
  
  return null;
};

export default { getAppVersion };

